import script from "./PlayControl.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayControl.vue?vue&type=script&setup=true&lang=js"

import "./PlayControl.vue?vue&type=style&index=0&id=3a7ef98e&lang=css"

const __exports__ = script;

export default __exports__